import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import type { PreviewWrapperProps } from '@wix/editor-elements-types/thunderboltPreview';
import {
  TextAreaInputDefinition,
  ITextAreaInputMapperProps,
} from '../TextAreaInput.types';
import { props as viewerPropsMapper } from './TextAreaInput.mapper';

const props = composeMapper<
  PreviewWrapperProps<ITextAreaInputMapperProps>,
  TextAreaInputDefinition
>()(
  viewerPropsMapper,
  { add: ['shouldResetComponent', 'componentViewMode', 'compPreviewState'] },
  (resolver, deps, carmiData) => {
    const viewerProps = resolver(deps, carmiData);
    const { shouldResetComponent, componentViewMode, compPreviewState } = deps;

    return {
      ...viewerProps,
      previewWrapperProps: {
        shouldResetComponent,
        componentViewMode,
        compPreviewState,
      },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
